import React from 'react'
import styled from 'styled-components'

const Video = () => {
    return (

        <Section>
            <iframe width="90%" height="500px" src="https://www.youtube.com/embed/1LN63p65aCA?si=LNVki4f41Zjyb6n5" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </Section>
    )
}

const Section = styled.section`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
`

export default Video